import { useState } from "react";
import { Copy, Check, ChevronRight } from "lucide-react";
import { toast } from "sonner";

function Stage({ label, value, testid }) {
  return (
    <div className="flex flex-col items-start min-w-0">
      <p className="label-tag text-[9px] mb-1 whitespace-nowrap">{label}</p>
      <p className="font-mono text-2xl font-semibold text-sand-950 leading-none" data-testid={testid}>{value}</p>
    </div>
  );
}

export default function ForwardingFunnel({ email, funnel, usage }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(email);
    } catch (e) {
      const ta = document.createElement("textarea");
      ta.value = email; document.body.appendChild(ta); ta.select();
      document.execCommand("copy"); document.body.removeChild(ta);
    }
    setCopied(true);
    toast.success("Copied to clipboard");
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div className="rounded-card border border-hairline bg-surface" data-testid="forwarding-funnel">
      <div className="grid lg:grid-cols-2 divide-y lg:divide-y-0 lg:divide-x divide-sand-200">
        {/* Terminal-style forwarding address */}
        <div className="p-6">
          <p className="label-tag mb-3">Forward reservations to</p>
          <button
            onClick={copy}
            className="w-full flex items-center gap-3 border border-dashed border-sand-400 px-4 py-3 hover:border-ember hover:bg-sand-50 transition-colors group text-left"
            data-testid="copy-forwarding-btn"
          >
            <span className="font-mono text-sand-400 select-none">&gt;</span>
            <code className="font-mono text-sm md:text-base text-sand-950 break-all flex-1" data-testid="forwarding-address">
              {email}
            </code>
            {copied
              ? <Check size={16} className="text-success shrink-0" />
              : <Copy size={16} className="text-sand-400 group-hover:text-ember shrink-0" />}
          </button>
          <p className="text-xs text-sand-500 mt-3">
            Any airline, hotel, car, or ticket confirmation — parsed automatically.
          </p>
        </div>

        {/* Funnel counters */}
        <div className="p-6 flex items-center">
          <div className="flex items-center gap-3 md:gap-5 flex-wrap w-full">
            <Stage label="Received" value={funnel.received} testid="funnel-received" />
            <ChevronRight size={14} className="text-sand-300 mt-3" />
            <Stage label="Parsed" value={funnel.parsed} testid="funnel-parsed" />
            <ChevronRight size={14} className="text-sand-300 mt-3" />
            <Stage label="Reservations" value={funnel.reservations} testid="funnel-reservations" />
            <ChevronRight size={14} className="text-sand-300 mt-3" />
            <Stage label="Trips" value={funnel.trips} testid="funnel-trips" />
            {usage && (
              <div className="ml-auto hidden md:block text-right">
                <p className="label-tag text-[9px] mb-1">Extractions today</p>
                <p className="font-mono text-sm text-sand-600" data-testid="funnel-usage">{usage.used} / {usage.limit}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
